import React from 'react';
import Row from 'components/row';
import Col from 'components/col';
import FormInput from 'components/form-input';
import NumberInput from 'components/form-number-input';
import DateInput from 'components/form-datepicker';
import ctrl from 'controllers/cotacao-ctrl';
import AvisoPreco from 'views/cotacao/aviso-preco';
import FormTextArea from 'components/form-textarea';

module.exports = React.createClass({

  linkState(propName){
    var self = this;
    return {
      value: this.props.item[propName],
      requestChange(newValue){
        self.props.item[propName] = newValue;
        self.forceUpdate();
      }
    }
  },

  focusEditControl(){
    this.refs.editEan.focus();
  },

  clearErrorMessage(){
    delete ctrl.ofertaErrorMessage;
    this.forceUpdate();
  },

  handleBlurCodigo(){
    var self = this;
    if (this.isMounted()) {
      if (this.props.item.codEan !== this.props.item.codEanOri) {

        var handleData = (data) => {
          var item = self.props.item;
          if (data.found) {
            item.descricao = data.produto.descricao;
            item.idProd = data.produto.idProd;
          } else {
            item.descricao = '';
            delete item.idProd;
          }
          self.forceUpdate();
        };

        if (this.props.item.codEan) {
          ctrl.requestProd(this.props.item.codEan).success(handleData)
        } else {
          handleData({found: false});
        }
      }
    }
  },

  render(){

    return (
      <form>
        <Row>
          <FormInput ref="editEan" size="sm-4 lg-3" label="Código EAN" valueLink={this.linkState("codEan")} onBlur={this.handleBlurCodigo} />
          <FormInput size="sm-8 lg-9" label="Descrição" valueLink={this.linkState("descricao")} disabled={this.props.item.idProd}/>
        </Row>
        <Row>
          <FormInput size="md-3 xs-6 lg-2" label="Un." valueLink={this.linkState("unidade")} maxLength={3} upperCase={true} />
          <NumberInput size="md-3 xs-6 lg-2" label="Embalagem" valueLink={this.linkState("embalagem")} />
          <NumberInput size="md-3 xs-6 lg-2" label="Preço (*)" valueLink={this.linkState("preco")} decPlaces={2} />
          <NumberInput size="md-3 xs-6 lg-3" label="Pgto (dias)" valueLink={this.linkState("prazoPagamento")} />
          <NumberInput size="md-3 xs-6 lg-3" label="Entrega (dias)" valueLink={this.linkState("prazoEntrega")} />
        </Row>
        <Row>
          <DateInput size="md-6 xs-12" label="Validade Oferta" valueLink={this.linkState("dtValidadeOferta")} />
          <DateInput size="md-6 xs-12" label="Validade Produto" valueLink={this.linkState("dtValidadeProduto")} />
        </Row>
        <Row>
          <FormTextArea size="sm-12" valueLink={this.linkState("obs")} label="Observações" rows="3" />
        </Row>        
        <AvisoPreco />
        <div className="row" style={{display: (ctrl.ofertaErrorMessage) ? 'block' : 'none'}}>
          <div className="col-sm-12" onClick={this.clearErrorMessage}>
            <div className="dialog-error-row">{ctrl.ofertaErrorMessage}</div>
          </div>
        </div>
      </form>
    );
  }

});


/** WEBPACK FOOTER **
 ** ./src/views/ofertar/oferta-item-form.js
 **/